import lodash from "lodash";
import { createColumnInlineInput, createColumnInlineInputNumber, createColumnInlineRadioGroup } from "../../../../../components/table/c-table.logic";
import i18n from "../../../../../i18n";
import store from "../../../../../store";
import { createButtonCreate } from "../../../../../utils/button";
import { conditionFormChecker, onClickDeleteAllClient } from "../../../../../utils/form";
import { createLoading } from "../../../../../utils/loading";
import { createManageDelete, createManageExportCsv, createPage } from "../../../../../utils/page";
import { callStorageLocationSubType, createField } from "./storage-location-sub.section";

export const { isLoading, setIsLoading } = createLoading();

export const actionPrefix = "resource/v1/transaction/storageLocationSub";

export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria });

export const createColumns = ({ props, data }) => {
    const { viewOnly, itemsKey } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    const columns = [];
    columns.push(
        createColumnInlineRadioGroup({
            title: () => i18n.global.t("views.request.storageLocationSub.refType"),
            dataIndex: "refType",
            items,
            useForm,
            itemsKey,
            inputProp: () => ({ list: callStorageLocationSubType, optLabel: "value" }),
            customRenderInputProp: ({ record, key }) =>
                lodash.merge(
                    {
                        disabled: viewOnly,
                        list: callStorageLocationSubType,
                        optLabel: "value",
                        type: "vertical",
                        "onUpdate:value": value => {
                            record.refType = value;
                            record.totalWidth = null;
                            record.totalLong = null;
                            record.totalHigh = null;
                            record.totalArea = null;
                            record.totalCapacity = null;
                            record.useWidth = null;
                            record.useLong = null;
                            record.useHigh = null;
                            record.useArea = null;
                            record.useCapacity = null;
                            record.useKg = null;
                        }
                    },
                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key } } })
                ),
            width: 100
        })
    );
    columns.push(
        createColumnInlineInput({
            title: () => i18n.global.t("model.storageLocationSub.buildingName"),
            dataIndex: "buildingName",
            items,
            useForm,
            itemsKey,
            customRenderInputProp: ({ key }) =>
                lodash.merge({ disabled: viewOnly }, conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key } } })),
            width: 150
        })
    );
    columns.push({
        title: () => i18n.global.t("views.request.storageLocationSub.total"),
        visible: () => true,
        children: [
            createColumnInlineInputNumber({
                title: () => i18n.global.t("views.request.storageLocationSub.totalWidth"),
                dataIndex: "totalWidth",
                items,
                useForm,
                itemsKey,
                customRenderInputProp: ({ record, key }) => {
                    return lodash.merge(
                        {
                            disabled: viewOnly || !record.refType || record.refType?.key === "2",
                            allowPrecision: true,
                            "onUpdate:value": value => {
                                record.isSave = true;
                                record.totalWidth = value;
                                calArea({
                                    model: record,
                                    width: record.totalWidth,
                                    long: record.totalLong,
                                    height: record.totalHigh,
                                    setArea: "totalArea",
                                    setCube: "totalCapacity"
                                });
                            }
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key } } })
                    );
                },
                width: 100,
                sorter: false
            }),
            createColumnInlineInputNumber({
                title: () => i18n.global.t("views.request.storageLocationSub.totalLong"),
                dataIndex: "totalLong",
                items,
                useForm,
                itemsKey,
                customRenderInputProp: ({ record, key }) => {
                    return lodash.merge(
                        {
                            disabled: viewOnly || !record.refType || record.refType?.key === "2",
                            allowPrecision: true,
                            "onUpdate:value": value => {
                                record.isSave = true;
                                record.totalLong = value;
                                calArea({
                                    model: record,
                                    width: record.totalWidth,
                                    long: record.totalLong,
                                    height: record.totalHigh,
                                    setArea: "totalArea",
                                    setCube: "totalCapacity"
                                });
                            }
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key } } })
                    );
                },
                width: 100,
                sorter: false
            }),
            createColumnInlineInputNumber({
                title: () => i18n.global.t("views.request.storageLocationSub.totalHigh"),
                dataIndex: "totalHigh",
                items,
                useForm,
                itemsKey,
                customRenderInputProp: ({ record, key }) => {
                    return lodash.merge(
                        {
                            disabled: viewOnly || !record.refType || record.refType?.key === "2",
                            allowPrecision: true,
                            "onUpdate:value": value => {
                                record.isSave = true;
                                record.totalHigh = value;
                                calArea({
                                    model: record,
                                    width: record.totalWidth,
                                    long: record.totalLong,
                                    height: record.totalHigh,
                                    setArea: "totalArea",
                                    setCube: "totalCapacity"
                                });
                            }
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key } } })
                    );
                },
                width: 100,
                sorter: false
            }),
            createColumnInlineInputNumber({
                title: () => i18n.global.t("views.request.storageLocationSub.totalArea"),
                dataIndex: "totalArea",
                items,
                useForm,
                itemsKey,
                customRenderInputProp: ({ record, key }) => {
                    return lodash.merge(
                        { disabled: viewOnly || !record.refType || record.refType?.key === "1", allowPrecision: true },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key } } })
                    );
                },
                width: 110,
                sorter: false
            }),
            createColumnInlineInputNumber({
                title: () => i18n.global.t("views.request.storageLocationSub.totalCapacity"),
                dataIndex: "totalCapacity",
                items,
                useForm,
                itemsKey,
                customRenderInputProp: ({ record, key }) => {
                    return lodash.merge(
                        { disabled: viewOnly || !record.refType || record.refType?.key === "1", allowPrecision: true },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key } } })
                    );
                },
                width: 110,
                sorter: false
            })
        ]
    });
    columns.push({
        title: () => i18n.global.t("views.request.storageLocationSub.use"),
        visible: () => true,
        children: [
            createColumnInlineInputNumber({
                title: () => i18n.global.t("views.request.storageLocationSub.useWidth"),
                dataIndex: "useWidth",
                items,
                useForm,
                itemsKey,
                customRenderInputProp: ({ record, key }) => {
                    return lodash.merge(
                        {
                            disabled: viewOnly || !record.refType || record.refType?.key === "2",
                            allowPrecision: true,
                            "onUpdate:value": value => {
                                record.isSave = true;
                                record.useWidth = value;
                                calArea({
                                    model: record,
                                    width: record.useWidth,
                                    long: record.useLong,
                                    height: record.useHigh,
                                    setArea: "useArea",
                                    setCube: "useCapacity",
                                    setKg: "useKg"
                                });
                            }
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key } } })
                    );
                },
                width: 100,
                sorter: false
            }),
            createColumnInlineInputNumber({
                title: () => i18n.global.t("views.request.storageLocationSub.useLong"),
                dataIndex: "useLong",
                items,
                useForm,
                itemsKey,
                customRenderInputProp: ({ record, key }) => {
                    return lodash.merge(
                        {
                            disabled: viewOnly || !record.refType || record.refType?.key === "2",
                            allowPrecision: true,
                            "onUpdate:value": value => {
                                record.isSave = true;
                                record.useLong = value;
                                calArea({
                                    model: record,
                                    width: record.useWidth,
                                    long: record.useLong,
                                    height: record.useHigh,
                                    setArea: "useArea",
                                    setCube: "useCapacity",
                                    setKg: "useKg"
                                });
                            }
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key } } })
                    );
                },
                width: 100,
                sorter: false
            }),
            createColumnInlineInputNumber({
                title: () => i18n.global.t("views.request.storageLocationSub.useHigh"),
                dataIndex: "useHigh",
                items,
                useForm,
                itemsKey,
                customRenderInputProp: ({ record, key }) => {
                    return lodash.merge(
                        {
                            disabled: viewOnly || !record.refType || record.refType?.key === "2",
                            allowPrecision: true,
                            "onUpdate:value": value => {
                                record.isSave = true;
                                record.useHigh = value;
                                calArea({
                                    model: record,
                                    width: record.useWidth,
                                    long: record.useLong,
                                    height: record.useHigh,
                                    setArea: "useArea",
                                    setCube: "useCapacity",
                                    setKg: "useKg"
                                });
                            }
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key } } })
                    );
                },
                width: 100,
                sorter: false
            }),
            createColumnInlineInputNumber({
                title: () => i18n.global.t("views.request.storageLocationSub.useArea"),
                dataIndex: "useArea",
                items,
                useForm,
                itemsKey,
                customRenderInputProp: ({ record, key }) => {
                    return lodash.merge(
                        { disabled: viewOnly || !record.refType || record.refType?.key === "1", allowPrecision: true },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key } } })
                    );
                },
                width: 110,
                sorter: false
            }),
            createColumnInlineInputNumber({
                title: () => i18n.global.t("views.request.storageLocationSub.useCapacity"),
                dataIndex: "useCapacity",
                items,
                useForm,
                itemsKey,
                customRenderInputProp: ({ record, key }) => {
                    return lodash.merge(
                        {
                            disabled: viewOnly || !record.refType || record.refType?.key === "1",
                            allowPrecision: true,
                            "onUpdate:value": value => {
                                record.isSave = true;
                                record.useCapacity = value;
                                if (value?.toString()) record.useKg = parseFloat(value) * 1000;
                            }
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key } } })
                    );
                },
                width: 110,
                sorter: false
            }),
            createColumnInlineInputNumber({
                title: () => i18n.global.t("views.request.storageLocationSub.useKg"),
                dataIndex: "useKg",
                items,
                useForm,
                itemsKey,
                customRenderInputProp: ({ key }) => {
                    return lodash.merge(
                        { disabled: true, allowPrecision: true },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key } } })
                    );
                },
                width: 100,
                sorter: false
            })
        ]
    });
    return columns;
};

export const initData = ({ props, data }) => {
    const { menuContext, viewOnly, itemsKey, canCreate, canDelete } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    data.columns = createColumns({ props, data });
    data.page = createPage({ data: items });
    data.tableOptions = { search: { activeKey: null } };
    data.manages = [
        createManageDelete({
            menuContext,
            visible: () => (viewOnly ? false : canDelete),
            onClick: ({ rowSelection }) => {
                onClickDeleteAllClient({ rowSelection, useForm, items, key: itemsKey });
                data.page.page = 0;
            }
        }),
        createManageExportCsv({ menuContext })
    ];
    data.manageExtras = [
        {
            render: () => createButtonCreate({ onClick: () => items.push({}) }),
            visible: () => (viewOnly ? false : canCreate)
        }
    ];
    data.rowActions = [];
    fetchData({ props, data }).then(page => items.push(...page.data));
};

export const fetchData = ({ props }) => {
    const { fetchCriteria } = props;
    if (!fetchCriteria || fetchCriteria.fetched) {
        return Promise.resolve({ data: [] });
    }
    fetchCriteria.fetched = true;
    setIsLoading(true);
    return callSearch({ criteria: fetchCriteria }).finally(() => setIsLoading(false));
};

export const initForm = ({ props, data, refs }) => {
    const key = props.dataKey;
    const isLoading = props.isLoading;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    data.fields = createField({ props, data, refs, key, isLoading });
    if (model.id) {
        data.sub = {
            fetchCriteria: {
                select: ["*", "refType.*"],
                page: 0,
                size: 1000000,
                where: [{ name: "refStorageLocation.id", type: "UUID", operator: "=", value: model.id }],
                sort: [{ name: "createDate", type: "ASC" }]
            }
        };
    }
};

const calArea = ({ model, width, long, height, setArea, setCube, setKg }) => {
    if (width?.toString() && long?.toString() && setArea) lodash.set(model, setArea, parseFloat(width) * parseFloat(long));
    if (width?.toString() && long?.toString() && height?.toString() && setCube)
        lodash.set(model, setCube, parseFloat(width) * parseFloat(long) * parseFloat(height));
    if (width?.toString() && long?.toString() && height?.toString() && setKg)
        lodash.set(model, setKg, parseFloat(width) * parseFloat(long) * parseFloat(height) * 1000);
};
